const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { name: "underwear/underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

const seoPages = [
  { name: "YOYBUY vs KAKOBUY", path: "/yoybuy-vs-kakobuy" },
  { name: "YOYBUY vs SUPERBUY", path: "/yoybuy-vs-superbuy" },
  { name: "KAKOBUY vs SUPERBUY", path: "/kakobuy-vs-superbuy" },
  { name: "Альтернатива SUPERBUY", path: "/superbuy-alternative" },
  { name: "FAQ", path: "/faq" },
  { name: "Руководство", path: "/article" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading font-semibold text-foreground-950 mb-4">
              YOYBUY Spreadsheet
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Самый выгодный способ покупать в Китае через Spreadsheet. Экономьте
              до 40% без посредников и скрытых комиссий.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              Категории
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              SEO страницы
            </h4>
            <ul className="space-y-2">
              {seoPages.map((page) => (
                <li key={page.path}>
                  <a
                    href={page.path}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {page.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              Перейти на платформу
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 px-4 py-2 rounded-md whitespace-nowrap text-center transition-colors"
              >
                yoybuy sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm font-medium bg-accent-500 text-white hover:bg-accent-600 px-4 py-2 rounded-md whitespace-nowrap text-center transition-colors"
              >
                buy it now
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-sm">
            © 2026 yoybuy.us — Все права защищены
          </p>
          <div className="flex gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 hover:text-primary-500 text-sm transition-colors"
            >
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}